export { default } from "./ConditionsInbox";
